export default __webpack_public_path__ + "static/media/weatherShiftLogo.857f751d.png";